import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import * as styles from '../ProfileCard.styles';

export const ProfileCardSkeletonBase = () => (
  <div css={styles.container}>
    <Skeleton height={48} width={48} circle />

    <div css={styles.item}>
      <Skeleton height={24} width={220} />

      <Skeleton height={24} width={150} />
    </div>

    <div css={styles.lineSeparator} />

    <div css={styles.content}>
      <div css={styles.item}>
        <Skeleton height={24} width={56} />

        <div css={styles.statistics}>
          <Skeleton height={24} width={40} />
        </div>
      </div>

      <div css={styles.verticalSeparator} />

      <div css={styles.item}>
        <Skeleton height={24} width={56} />

        <div css={styles.statistics}>
          <Skeleton height={24} width={40} />
        </div>
      </div>
    </div>
  </div>
);

ProfileCardSkeletonBase.displayName = 'ProfileCardSkeleton';

export const ProfileCardSkeleton = memo(ProfileCardSkeletonBase);
